export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Summary.vue?vue&type=template&id=6180da24&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/summary/Summary.vue?vue&type=template&id=6180da24&scoped=true&
// module id = 1550
// module chunks = 0